import 'core-js-pure/actual/array/find-last';
import 'core-js-pure/actual/array/find-last-index';
import { peekAnalyticsPlugin } from '@peek-tech/peek-analytics';
import { getOrMintSessionId, peekAnalyticsStorage } from '@peek-tech/peek-analytics/browser';

// Every app in this repo talks to the web-events API through the shared client; this wrapper
// exists so they all read the endpoint from the same env var instead of each naming it.
const analyticsPlugin = ({ appId, app, enabled = true, identifyUserField, context, }) => {
    // The API request interceptors stamp the session id from sessionStorage, and the first
    // request can go out before the first event, so the id has to exist from the start.
    getOrMintSessionId();
    return peekAnalyticsPlugin({
        apiUrl: process.env.PEEK_APP_ANALYTICS_API_URL,
        appId,
        app,
        enabled,
        identifyUserField,
        context,
    });
};
const analyticsStorage = peekAnalyticsStorage;
const getWebViewerRoomData = (analyticsState) => {
    var _a;
    return (_a = analyticsState.track.history.findLast(({ event }) => event === "Room View")) === null || _a === void 0 ? void 0 : _a.properties;
};
const isWebViewerCTAForm = (analyticsState) => {
    const lastOpenedCTAFromIndex = analyticsState.track.history.findLastIndex(({ event }) => event === "CTA_Form_Opened");
    // If no "CTA_Form_Opened" event is found, return false
    if (lastOpenedCTAFromIndex === -1) {
        return false;
    }
    // Check if "CTA_Form_Closed" occurs after the last "CTA_Form_Opened"
    return analyticsState.track.history
        .slice(lastOpenedCTAFromIndex)
        .findIndex(({ event }) => event === "CTA_Form_Closed") !== -1
        ? false
        : true;
};
const getEnrichedTrackWithRoomData = (plugin) => {
    return (eventData) => {
        const { instance, payload: { properties }, } = eventData;
        const roomData = getWebViewerRoomData(instance.getState()) || {};
        plugin.track(Object.assign(Object.assign({}, eventData), { payload: Object.assign(Object.assign({}, eventData.payload), { properties: Object.assign(Object.assign({}, roomData), properties) }) }));
    };
};

export { analyticsPlugin, analyticsStorage, analyticsPlugin as default, getEnrichedTrackWithRoomData, getWebViewerRoomData, isWebViewerCTAForm };
